import axiosInstance from '@/axios'

const setManagerToUser = ({managerEmail, userEmail}) => {
  return axiosInstance.post(`/api/profile/admin/managers/${managerEmail}/users/${userEmail}`);
}

export {
  setManagerToUser,
}